import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../../../services/authentication.service';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {GlobalPaymentFormComponent} from '../../../../shared/components/forms/global-payment-form/global-payment-form.component';
import {UserService} from '../../../../services/user-services/user.service';
import {ProcessService} from '../../../../services/user-services/process.service';
import {ProcessSharedService} from '../../../../services/process-shared.service';
//import { MetaService } from 'src/app/services/meta.service';
//import {TiktokService} from '../../../../services/tiktok.service';
import {TranslateModule} from '@ngx-translate/core';
import {CheckFormErrorDirective} from '../../../../directives/checkFormError.directive';
import {NgClass, NgIf} from '@angular/common';
import {NeedHelpComponent} from '../../../../shared/components/ux/need-help/need-help.component';
import {FaqAccordionComponent} from '../../../../components/faq-accordion/faq-accordion.component';
import {HelperService} from "../../../../services/helper.service";
import { LocalSettingsService } from 'src/app/services/local-settings.service';

@Component({
  selector: 'app-hc-component-payment',
  templateUrl: './hc-component-payment.component.html',
  styleUrls: ['./hc-component-payment.component.scss'],
  standalone: true,
  imports: [GlobalPaymentFormComponent, FaqAccordionComponent, NeedHelpComponent, NgIf, CheckFormErrorDirective, NgClass, TranslateModule]
})
export class HcComponentPaymentComponent implements OnInit {

  @Input() price = 199;
  @Input() promoCode: string;
  private isLogged = false;
  FaqItems:any;
  isMobile = false;
  process;
  public isLoading = false;
  public displayBtn = true;
  currentUser;
  currentLanguage;

  @ViewChild('globalPaymentFormComponent') private globalPaymentFormComponent: GlobalPaymentFormComponent;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private processService: ProcessService,
    private sharedProcessService: ProcessSharedService,
    //private metaService: MetaService,
   // private tikTokService: TiktokService,
    private helperService: HelperService,
    private localSettings: LocalSettingsService,

  ) { }

  ngOnInit(): void {
    this.currentLanguage = this.localSettings.getLanguage();
    this.currentUser = this.userService.getInfos();
    //this.metaService.sendPageView('ViewHC',this.router.url,this.currentUser ? this.currentUser.id : 0,0,'hc').subscribe();
   // this.tikTokService.sendPageView('URL achat attestation', this.router.url, this.currentUser ? this.currentUser.id : 0,'page paiement');
    if (this.authenticationService.currentUserValue) {
      const hubDatas = {amount: this.price.toFixed(2)};
      this.userService.setHubspotDeal(6459040, 19276179, hubDatas).subscribe();
      this.isLogged = true;
      this.isMobile = this.userService.isMobileUser;
      this.sharedProcessService.getPageFaq('attestation-payment').pipe(take(1)).subscribe( (data) => {
        this.FaqItems = data;
      } );
    } else {
      this.router.navigate([this.currentLanguage+'/housing-certificate/informations'])
    }
  }

  pay() {
    let hubDatas = {
      amount: this.price.toFixed(2),
      campagne: '',
      source: '',
      medium: ''
    };

    hubDatas = this.helperService.setUtmToHubspot(hubDatas);
    //this.metaService.sendBuy(this.router.url,this.price,this.currentUser ? this.currentUser.id : 0).subscribe();
    this.userService.setHubspotDeal(6459040, 19276179, hubDatas).subscribe();
    this.globalPaymentFormComponent.pay();
    this.process = this.processService.getProcess('HOUSING-CERTIFICATE');
    if (this.process) {
      this.sharedProcessService.updateProcessState('DONE', this.process).subscribe();
    }
  }

  public displayButton(e) {
    this.displayBtn = e;
  }

}
